
import { useEffect, useState } from 'react';

/**
 * Custom hook for handling scroll progress indicator
 * @returns Object containing scroll progress and helper functions
 */
export const useScrollSections = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  // Handle scroll progress indicator
  const handleScrollProgress = () => {
    const windowHeight = document.documentElement.scrollHeight - window.innerHeight;
    const currentScroll = window.scrollY;
    const scrollPercentage = (currentScroll / windowHeight) * 100;
    setScrollProgress(Math.min(Math.max(scrollPercentage, 0), 100));
  };

  const smoothScrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    // Initialize scroll progress
    handleScrollProgress();
    
    // Add scroll event listener
    window.addEventListener('scroll', handleScrollProgress, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScrollProgress);
    };
  }, []);

  return {
    scrollProgress,
    handleScrollProgress,
    smoothScrollToSection,
  };
};
